document.addEventListener("DOMContentLoaded", function () {

  new Swiper(".upsell-swiper", {
    slidesPerView: 1.1,
    spaceBetween: 15,
    navigation: {
      nextEl: ".upsell-next",
      prevEl: ".upsell-prev"
    },
  });

  const mainAddToCart = document.querySelector("button[type='submit'][name='add']");
  if (!mainAddToCart) return;

  mainAddToCart.addEventListener("click", function () {
    setTimeout(() => {
      const checked = document.querySelectorAll(".upsell-check:checked");
      if (!checked.length) return;

      const items = [];

      checked.forEach(chk => {
        items.push({
          id: chk.dataset.variant,
          quantity: 1
        });
      });

      // Add all items in one API call
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      })
      .then(r => r.json())
      .then(() => {
        // Refresh cart drawer
        document.body.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch(err => console.error("Upsell error:", err));
    }, 300);
  });

});